/**
* 店铺管理 客户账期管理
*/
<template>
  <div class="contianer">
    <!-- 搜索筛选 -->
    <el-form :inline="true" :model="formInline" class="user-search">
      <el-form-item label="">
        <el-input size="small" v-model="formInline.company_code" placeholder="手机号" clearable></el-input>
      </el-form-item>
      <el-form-item label="">
        <el-input size="small" v-model="formInline.company_name" placeholder="客户单位名称" clearable></el-input>
      </el-form-item>
      <el-form-item>
        <el-button size="small" type="primary" @click="search">查询</el-button>
        <el-button size="small" type="success" @click="addflashdialog" class="add-button">新增</el-button>
        <el-button size="small" type="info" @click="editflashdialog" class="edit-button">修改</el-button>
      </el-form-item>
    </el-form>
    <!--列表-->
    <div style="height: 530px;overflow-y: auto">
      <el-table size="small" :data="listData" highlight-current-row v-loading="loading" border
                @cell-dblclick="cellDbClick" @selection-change="handleSelectionChange"
                :header-cell-style="{background:'#F5F7FA',color:'#666666'}"
                element-loading-text="拼命加载中" style="width: 100%;">
        <el-table-column align="center" type="selection" width="60">
        </el-table-column>
        <el-table-column
          label="序号"
          width="60">
          <template slot-scope="scope">
            {{pageparm.pageSize * (pageparm.currentPage - 1) + (scope.$index + 1)}}
          </template>
        </el-table-column>
        <el-table-column prop="company_code" label="手机号" width="150" :show-overflow-tooltip='true'>
        </el-table-column>
        <el-table-column prop="company_name" label="客户单位" min-width="220" :show-overflow-tooltip='true'>
        </el-table-column>
        <el-table-column prop="account_period_money" label="账期额度" width="180" :show-overflow-tooltip='true'>
        </el-table-column>
        <el-table-column prop="used_money" label="已用额度" width="180" :show-overflow-tooltip='true'>
        </el-table-column>
        <el-table-column prop="account_period_days" label="账期天数" width="180" :show-overflow-tooltip='true'>
        </el-table-column>
        <el-table-column prop="creater_name" label="创建人" width="150" :show-overflow-tooltip='true'>
        </el-table-column>
        <el-table-column prop="creater_time" label="创建时间" width="220" :show-overflow-tooltip='true'>
          <template slot-scope="scope">
            <div>{{scope.row.creater_time|timestampToTime}}</div>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 分页组件 -->
    <Pagination v-bind:child-msg="pageparm" @callFather="callFather"></Pagination>
    <el-dialog :close-on-click-modal="false" :close-on-press-escape="false"
               :title="dialogTitle"
               :visible.sync="flashDialogVisible"
               width="30%"
               top="7vh"
               :before-close="handleClose"
               center>
      <el-form :model="flashForm" :rules="rules" ref="flashForm" label-width="155px" class="flashForm">
        <el-form-item label="单位名称" prop="cust_company_id">
          <el-select v-model="flashForm.cust_company_id" filterable placeholder="请填写单位名称" clearable
                     remote :filter-method="remoteMethod" class="productInterval" :popper-append-to-body="false"
                     @focus="focusRuleName()" @change="changeRuleName()" @clear="clear()" :disabled="custDisabled">
            <el-option :title="item.company_name"
                       v-for="item in codeData"
                       :key="item.company_id"
                       :label="item.company_name"
                       :value="item.company_id">
            </el-option>
            <div class="pagination-absolute">
              <el-pagination :small="small" style="height: 30px;margin-top: 8px"
                             @size-change="ruleHandleSizeChange"
                             @current-change="ruleHandleCurrentChange"
                             :current-page.sync="ruleCurrentPage"
                             :page-size="rulePagesize"
                             layout="total, prev, pager, next"
                             :total="ruleTotalSize">
              </el-pagination>
            </div>
          </el-select>
        </el-form-item>
<!--        <el-form-item label="客户单位" prop="company_name" class="relative">-->
<!--          <el-input v-model="flashForm.company_name" clearable disabled placeholder="请输入客户单位">-->
<!--          </el-input>-->
<!--        </el-form-item>-->
        <el-form-item label="账期额度" prop="account_period_money" class="relative">
          <el-input v-model="flashForm.account_period_money" clearable maxlength="8" placeholder="请填写账期额度">
          </el-input>
        </el-form-item>
        <el-form-item label="账期天数" prop="account_period_days" class="relative">
          <el-input v-model="flashForm.account_period_days" clearable maxlength="9" placeholder="请填写账期天数">
          </el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
            <el-button @click="handleClose">取 消</el-button>
            <el-button type="primary" @click="saveSort('flashForm')">确 认</el-button>
      </span>
    </el-dialog>

  </div>
</template>
<script>
import {
  accountList,
  accountAdd,
  accountModify,
  accountCompanyList, CouponusagerulesList
} from '../../api/basisMG'
  import Pagination from '../../components/Pagination'
  import {timestampToTime} from '../../utils/util'

  export default {
    data: () => {
      var validateMoney = (rule, value, callback) => {
        if (value === '' || value == undefined || value == null) {
          return callback(new Error('请输入账期额度'));
        } else if (!(/(^[1-9]\d*$)/.test(value))) {
          return callback(new Error('请输入正整数'));
        } else {
          return callback();
        }
      };
      var validateDays = (rule, value, callback) => {
        if (value === '' || value == undefined || value == null) {
          return callback(new Error('请输入账期天数'));
        } else if (!(/(^[1-9]\d*$)/.test(value))) {
          return callback(new Error('请输入正整数'));
        } else {
          return callback();
        }
      };
      return {
        loading: false,
        flashDialogVisible: false,  // 弹窗
        dialogTitle: '',  // 标题
        voucherType: [],  // 优惠券类型
        productId: '',
        formInline: {
          page: 1,
          rows: 10,
          company_code: '',
          company_name: ''
        },
        flashForm: {
          id: "",
          cust_company_id: "",
          account_period_money: "",
          account_period_days: "",
          return_man: "",
          customer_man: "",
          company_name: "",
          company_id: ""
        },
        listData: [], //用户数据
        // 分页参数
        pageparm: {
          currentPage: 1,
          pageSize: 10,
          total: 10
        },
        sale_id: '',
        // rules表单验证
        rules: {
          cust_company_id: [{required: true, message: '请输入单位名称', trigger: 'blur'}],
          company_name: [{required: true, message: '请输入客户单位', trigger: 'blur'}],
          account_period_money: [{required: true, validator: validateMoney, trigger: 'blur'}],
          account_period_days: [{required: true, validator: validateDays, trigger: 'blur'}],
        },
        selectTableData: [],
        small: true,
        codeData: [],
        ruleCurrentPage: 1,
        rulePagesize: 10,
        ruleTotalSize: 0,
        companyName: '',
        selectedruleName: '',
        custDisabled: false
      }
    },
    // 注册组件
    components: {
      Pagination
    },
    /**
     * 创建完毕
     */
    created() {
      this.getdata(this.formInline)
    },
    mounted() {

    },
    /**
     * 里面的方法只有被调用才会执行
     */
    methods: {
      // 列表
      getdata(parameter) {
        this.loading = true
        accountList(parameter)
          .then(res => {
            this.loading = false
            if (res.success == false) {
              this.$message({
                type: 'info',
                message: res.msg
              })
            } else {
              this.listData = res.content.rows
              // 分页赋值
              this.pageparm.currentPage = this.formInline.page
              this.pageparm.pageSize = this.formInline.rows
              this.pageparm.total = res.content.total
            }
          })
          .catch(err => {
            this.loading = false
            this.$message.error('网络错误，请稍后再试！')
          })
      },
      // 分页插件事件
      callFather(parm) {
        this.formInline.page = parm.currentPage
        this.formInline.rows = parm.pageSize
        this.getdata(this.formInline)
      },
      // 新增客户账期弹窗
      addflashdialog() {
        this.flashDialogVisible = true;
        this.dialogTitle = '新增客户账期';
        this.custDisabled = false;
        this.flashForm = {
          id: "",
          cust_company_id: "",
          account_period_money: "",
          account_period_days: "",
          return_man: "",
          customer_man: "",
          company_name: "",
          company_id: ""
        };
        this.getCouponRule();
      },
      // 修改客户账期弹窗
      editflashdialog() {
        if (this.selectTableData.length == 0) {
          this.$message.error('请选择一条数据再操作!');
          return
        }
        if (this.selectTableData.length > 1) {
          this.$message.error('当前操作只能选择一条数据!');
          return
        }
        this.productId = this.selectTableData[0].id;
        this.custDisabled = true;
        this.flashDialogVisible = true;
        this.dialogTitle = '修改客户账期';
        // this.selectedruleName = this.selectTableData[0].company_name;
        this.flashForm.cust_company_id = this.selectTableData[0].company_name;
        this.flashForm.account_period_money = this.selectTableData[0].account_period_money;
        this.flashForm.account_period_days = this.selectTableData[0].account_period_days;
      },
      // 确认-新增客户账期
      saveSort(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            this.loading = true;
            if (this.dialogTitle == '新增客户账期') {
              accountAdd(this.flashForm)
                .then(res => {
                  this.loading = false
                  if (res.success == false) {
                    this.$message({
                      type: 'info',
                      message: res.msg
                    })
                  } else {
                    this.$message({
                      type: 'success',
                      message: '您已成功新增客户账期'
                    });
                    this.flashDialogVisible = false;
                    this.getdata(this.formInline)
                  }
                })
                .catch(err => {
                  this.loading = false
                  this.$message.error('网络错误,请稍后再试!')
                })
            } else {
              this.flashForm.id = this.selectTableData[0].id;
              accountModify(this.flashForm)
                .then(res => {
                  this.loading = false
                  if (res.success == false) {
                    this.$message({
                      type: 'info',
                      message: res.msg
                    })
                  } else {
                    this.$message({
                      type: 'success',
                      message: '您已成功修改客户账期'
                    });
                    this.flashDialogVisible = false;
                    this.getdata(this.formInline)
                  }
                })
                .catch(err => {
                  this.loading = false;
                  this.$message.error('网络错误,请稍后再试!')
                })
            }
          } else {
            console.log('error submit!!');
          }
        });
      },
      // 搜索事件
      search() {
        this.formInline.page = 1;
        this.getdata(this.formInline);
      },
      handleRemove(file) {
        console.log(file);
      },
      handleSelectionChange(val) {
        this.selectTableData = val
      },
      handleClick(tab, event) {
        console.log(tab, event);
      },
      handleClose() {
        this.$refs["flashForm"].resetFields();
        this.flashDialogVisible = false;
      },
      getCouponRule(companyName) {
        let param = {
          page: this.ruleCurrentPage,
          rows: 10,
          content: companyName
        }
        accountCompanyList(param)
          .then(res => {
            this.loading = false
            if (res.success == false) {
              this.$message({
                type: 'info',
                message: res.msg
              })
            } else {
              if (!res.content.rows.length) {
                this.selectedruleName = ''
              }
              this.codeData = res.content.rows;
              this.ruleTotalSize = res.content.total;
            }
          })
          .catch(err => {
            this.loading = false
            this.$message.error('网络错误，请稍后再试！')
          })
      },
      remoteMethod(val) {
        this.ruleCurrentPage = 1
        this.companyName = val;
        this.getCouponRule(val)
      },
      focusRuleName() {
        if (!this.selectedruleName) {
          this.companyName = ''
          this.getCouponRule('')
        }
      },
      changeRuleName() {
        this.ruleCurrentPage = 1
        this.codeData.forEach((item) => {
          if (item.company_id == this.flashForm.company_id) {
            this.selectedruleName = item.company_name;
            this.getCouponRule(item.company_name)
          }
        })
      },
      clear() {
        this.getCouponRule()
        this.ruleCurrentPage = 1
        this.companyName = ''
      },
      ruleHandleSizeChange(val) {
        //console.log(`每页 ${val} 条`);
        this.rulePagesize = val;
        this.getCouponRule(this.companyName)
      },
      ruleHandleCurrentChange(val) {
        //console.log(`当前页: ${val}`);
        this.ruleCurrentPage = val;
        this.getCouponRule(this.companyName)
      },
      //双击复制
      cellDbClick(row, column, cell, event) {
        if (row.company_code == cell.innerText || row.company_name == cell.innerText) {
          if (event.type === "dblclick") {
            var save = function (e) {
              e.clipboardData.setData('text/plain', cell.innerText);
              e.preventDefault();//阻止默认行为
            }
            document.addEventListener('copy', save);
            document.execCommand("copy");
            document.removeEventListener('copy', save);
          }
          this.$message({message: '复制成功', type: 'success'})
        }
      }
    }
  }

</script>

<style scoped>
  .contianer {
    background: #fff;
    padding: 20px;
  }

  /deep/ .user-search .el-input__inner {
    height: 40px;
    line-height: 40px;
  }

  /deep/ .user-search .el-form-item {
    margin-bottom: 10px;
  }

  /deep/ .user-search .el-button--small {
    height: 40px;
  }

  /deep/ .el-dialog--center {
    border-radius: 8px !important;
  }

  /deep/ .flashForm .el-input__inner {
    height: 40px;
    line-height: 40px;
    width: 320px;
  }

  /deep/ .flashForm .el-input {
    width: 320px;
  }

  /deep/ .flashForm .el-input--small {
    width: 320px;
  }

  /deep/ .textarea .el-textarea__inner {
    resize: none;
  }

  /deep/ .flashForm .el-form-item__label {
    position: relative;
    padding: 0 22px 0 0 !important;
  }

  /deep/ .flashForm .el-select-dropdown__list {
    padding-bottom: 50px;
    min-height: 150px;
  }

  /deep/ .flashForm .el-select-dropdown__item {
    width: 320px;
    overflow: hidden;
    white-space: nowrap;
    text-overflow: ellipsis;
  }

  /deep/ .flashForm .el-input--small {
    width: 320px;
  }

  /deep/ .el-message-box__title {
    color: #409EFF !important;
  }

  /deep/ .el-dialog__title {
    color: #409EFF !important;
  }

  .add-button {
    background: #53B03C;
    border-color: #53B03C;
  }

  .edit-button {
    background: #58B7D6;
    border-color: #58B7D6;
  }

  .pagination-absolute {
    position: absolute;
    bottom: 0;
    background: #fff;
    width: 95%;
    padding-left: 20px;
    height: 40px;
  }

</style>



// WEBPACK FOOTER //
// src/views/store/storeAccount.vue